export default {
  title: 'My messages',
  receptionTab: 'Received',
  sendTab: 'Sent',
  sendMessageButton: 'Send a message',
  headerObject: 'Topic',
  headerSubject: 'Subject',
  headerReceived: 'Received',
  headerSent: 'Sent',
  messagesDeletedSnackbar_one: 'Message deleted.',
  messagesDeletedSnackbar_many: '{{count}} messages deleted.',
  noMessages: 'No mail',
  subjectAdditionalTitle: 'Other:',
  labelCheckboxSelectAll: 'Select all',
  labelCheckboxSelect: 'Select',
  messageRowAriaLabel: 'Select',
};
